// Loại workspace ghi trong marker `.claude/avatar.json` (field `kind`) — card #254.
//
// Vì sao cần: extension "Avatar DataHub" dựng workspace phân tích dữ liệu (~/AvatarDataHub)
// có CLAUDE.md riêng + `.claude/avatar.json` (để `avatar ai *` nhận workspace). Marker đó làm
// `status`/`doctor` đăng ký thư mục vào registry ⇒ `avatar update` → `sync --all` → `avatar sync`
// thay CLAUDE.md, cài symlink farm + hook pack + tự bật tool dev. Workspace dạng đó khai
// `"kind": "datahub"`; CLI coi mọi `kind` ≠ "dev" là NGOÀI phạm vi `sync`/registry.
//
// File này chỉ là lớp vỏ IO. Luật parse nằm ở `workspace-kind-contract.ts` (thuần, dùng chung
// với extension qua `@nalvietnam/avatar-cli/core`). Thiếu file ⇒ "dev".
import { readFileSync } from "node:fs";
import { join } from "node:path";
import { DEV_WORKSPACE_KIND, parseWorkspaceMarkerKind } from "./workspace-kind-contract.js";
import { WORKSPACE_MARKER_RELATIVE } from "./workspace-marker-constants.js";

export { DEV_WORKSPACE_KIND };

export function readWorkspaceMarkerKind(workspaceRoot: string): string {
  let raw: string;
  try {
    raw = readFileSync(join(workspaceRoot, WORKSPACE_MARKER_RELATIVE), "utf8");
  } catch {
    return DEV_WORKSPACE_KIND;
  }
  return parseWorkspaceMarkerKind(raw);
}

/** `true` khi workspace KHÔNG phải loại dev ⇒ `sync` + registry phải đứng ngoài. */
export function isNonDevWorkspace(workspaceRoot: string): boolean {
  return readWorkspaceMarkerKind(workspaceRoot) !== DEV_WORKSPACE_KIND;
}
